import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=4b25a7f8&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=ts"
export * from "./Wallet.vue?vue&type=script&lang=ts"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=4b25a7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25a7f8",
  null
  
)

export default component.exports